var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    ref: "wkFileInput",
    staticStyle: { display: "none" },
    attrs: {
      name: _vm.data.name,
      multiple: _vm.data.multiple,
      accept: _vm.data.accept,
      type: "file",
    },
    on: { change: _vm.handleChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }